import { useCookieConsent } from '@/hooks/use-cookie-consent';
import { Button } from '@/components/ui/button';
import { CookieSettingsModal } from './cookie-settings-modal';

export function CookieBanner() {
  const { hasConsented, acceptAll, declineAll, openSettings } = useCookieConsent();

  if (hasConsented) {
    return <CookieSettingsModal />;
  }

  return (
    <>
      <div className="fixed bottom-0 left-0 right-0 z-[60] animate-in slide-in-from-bottom duration-500 fill-mode-forwards">
        <div className="border-t border-stone-200 bg-white shadow-[0_-4px_20px_rgba(0,0,0,0.08)]">
          <div className="mx-auto max-w-5xl px-4 py-4 sm:px-6 sm:py-5">
            <div className="flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between">
              <p className="text-sm text-stone-600 sm:max-w-xl">
                Folosim cookie-uri pentru a imbunatati experienta ta pe platforma.{' '}
                <a
                  href="/cookies"
                  className="font-medium text-primary underline-offset-4 hover:underline"
                >
                  Afla mai mult
                </a>
              </p>

              <div className="flex flex-shrink-0 flex-wrap items-center gap-2 sm:gap-3">
                <Button
                  variant="ghost"
                  size="sm"
                  onClick={openSettings}
                  className="text-stone-500 hover:text-stone-700"
                >
                  Personalizeaza
                </Button>
                <Button variant="outline" size="sm" onClick={declineAll}>
                  Refuza
                </Button>
                <Button size="sm" onClick={acceptAll}>
                  Accepta toate
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <CookieSettingsModal />
    </>
  );
}
